import { Identifiable, Status } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function isBasic(task: Identifiable<Status>): boolean {
  const basicStatuses = ["pr_done", "pr_in_progress", "pr_todo"];

  return !!basicStatuses.find((basicStatus) => basicStatus === task.label);
}

function createInteractor(repository: Repository): Interactor {
  return (project) =>
    present(
      repository
        .getTaskStatuses(project)
        .then((statuses) => ({
          project,
          statuses: statuses.map((status) => ({
            ...status,
            basic: isBasic(status),
          })),
        }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
